<div class="floatLabel registro" [ngClass]="{'soloLectura' : disabled}">

  <div class="dropdown select" [ngClass]="{'is-filled' : datoSeleccionado.length, 'margenControl' : margenControl }" dropdown >

    <!-- Menu -->
    <ul class="dropdown-menu multiselectCustom" aria-labelledby="multiSelect" style="width: 100%"  id="multiSelect{{id}}" #ddMenu>

      <!-- Panel Seleccionar -->
      <li *ngIf="seleccionarTodos" class="panelSeleccionarTodo">

        <div>
          <!-- Seleccionar todos -->
          <div class="seleciconar">
            <div (click)="CambiarSeleccionarTodos()">

              <ng-container *ngIf="!seleccionadosTodos">
                <div class="iconoSeleccionado"><span class="fa fa-square-o" ></span></div>
                <div class="texto">Seleccionar todo</div>
              </ng-container>

              <ng-container *ngIf="seleccionadosTodos">
                <div class="iconoSeleccionado"><span class="fa fa fa-check-square-o" ></span></div>
                <div class="texto">Deseleccionar todo</div>
              </ng-container>

            </div>
          </div>

          <!-- Limipiar -->
          <!--<div class="limpiar">
            <div *ngIf="limpiarInput" (click)="LimpiarSelect()">
              <span class="fa fa-ban"></span>
            </div>
          </div>-->
        </div>

      </li>

      <!-- Buscar -->
      <li class="" *ngIf="buscar">
        <div class="inputBuscardd limpieza">
          <input type="text" placeholder="Buscar" class="" id="buscar{{id}}" [(ngModel)]="busqueda"/>

          <div class="limpiarBusqueda" (click)="LimpiarBusqueda()" *ngIf="busqueda">
            <div>
              <span class="fa fa-times-circle-o"></span>
            </div>
          </div>
        </div>
      </li>

      <li *ngFor="let opcion of opciones | filtro: busqueda : [displayValor]">

        <a class="dropdown-item multiselectCustom"  (click)="SeleccionarOpcion(opcion)">

          <div>
            <div class="iconoSeleccion">
              <span class="fa fa-square-o " *ngIf="!opcion.Seleccionado"></span>
              <span class="fa fa-check-square-o seleccionado" *ngIf="opcion.Seleccionado"></span>
            </div>

            <div>
              <span class="opcionTitulo">{{opcion[displayValor]}}</span>
            </div>
          </div>


        </a>
      </li>

    </ul>

    <!-- Botón -->
    <div class="btnDropdown ddSelect {{clasesAdicionales}}" [ngClass]="{'disabled' : disabled}" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="FocusBuscar()">

      <!-- opciones seleccionadas -->
      <div class="texto" >
          {{cadenaSeleccionados}}
      </div>

      <!-- Limpiar control -->
      <div class="btnTimes dropdownTimes" *ngIf="limpiarInput && !disabled  && datoSeleccionado.length > 0" (click)="LimpiarSelect()">

        <span class="fa fa-times"></span>
      </div>

      <!-- icono dd -->
      <div class="abrir">
        <span class="fa fa-caret-down"></span>
      </div>

    </div>

    <!-- Mensaje error -->
    <span *ngIf="verError" class="textoError" [hidden]="datoSeleccionado && datoSeleccionado.length != 0 || !errorActivo">
      {{mensajeError}}
    </span>

  </div>

  <!-- Label (título del control) -->
  <label>{{titulo}}</label>

</div>
